import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

// common for status
export const updateStatus: any = createAsyncThunk<any>(
	'updateStatus',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`/productService/masterData/updateStatus`,
				{ ...data }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);

// Attributes
export const getAttributesList: any = createAsyncThunk<any>(
	'getAttributesList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/masterData/attribute',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getAttributesListMore: any = createAsyncThunk<any>(
	'getAttributesListMore',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/masterData/attribute',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const addAttributesList: any = createAsyncThunk<any>(
	'addAttributesList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/masterData/attribute',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updateAttributesList: any = createAsyncThunk<any>(
	'updateAttributesList',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`/productService/masterData/attribute`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
//unit
export const getUnitsList: any = createAsyncThunk<any>(
	'getUnitsList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/masterData/unit',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const addUnitsList: any = createAsyncThunk<any>(
	'addUnitsList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/masterData/unit',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updateUnitsList: any = createAsyncThunk<any>(
	'updateUnitsList',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`/productService/masterData/unit`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const deleteUnit: any = createAsyncThunk<any>(
	'deleteUnit',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.delete(
				`/productService/masterData/unit`,
				{ data: data }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
//brand
export const getBrandList: any = createAsyncThunk<any>(
	'getBrandList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/masterData/brand',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const addBrandList: any = createAsyncThunk<any>(
	'addBrandList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/masterData/brand',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updateBrandList: any = createAsyncThunk<any>(
	'updateBrandList',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`/productService/masterData/brand`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const deleteBrand: any = createAsyncThunk<any>(
	'deleteBrand',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.delete(
				`/productService/masterData/brand`,
				{ data: data }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
// attributes sets
export const getAttributesSetsList: any = createAsyncThunk<any>(
	'getAttributesSetsList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/masterData/attributeSet',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const addAttributesSetsList: any = createAsyncThunk<any>(
	'addAttributesSetsList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/masterData/attributeSet',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updateAttributesSetsList: any = createAsyncThunk<any>(
	'updateAttributesSetsList',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`/productService/masterData/attributeSet`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getAssociatedList: any = createAsyncThunk<any>(
	'getAssociatedList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/masterData/attributeAssociation',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getAssociatedListMore: any = createAsyncThunk<any>(
	'getAssociatedListMore',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/masterData/attributeAssociation',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updateAssociatedList: any = createAsyncThunk<any>(
	'updateAssociatedList',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`/productService/masterData/attributeAssociation`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);

// price lists
export const getPriceList: any = createAsyncThunk<any>(
	'getPriceList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'productService/masterData/price',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const addPriceList: any = createAsyncThunk<any>(
	'addPriceList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/masterData/price',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updatePriceList: any = createAsyncThunk<any>(
	'updatePriceList',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`/productService/masterData/price`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const deletePrice: any = createAsyncThunk<any>(
	'deletePrice',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.delete(
				`/productService/masterData/price`,
				{ data: data }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
